interface CanvasContext {
  measureText: (line: string) => {
    width: number;
  }
}

export function getWrappedWordsForCanvas(canvasContext: CanvasContext, text: string, x: number, y: number, maxWidth: number, lineHeight: number) {
  const lines = [];
  let line = '';

  while (text.length > 0) {
    const testLine = line + text.substring(0, 1);
    const lineWidth = canvasContext.measureText(testLine).width;

    if (lineWidth <= maxWidth) {
      line += text.substring(0, 1);
      text = text.substring(1);
      continue;
    }

    if (line === '') {
      // maxWidth is apparently less than the width of a single character.
      // Break to prevent infinite loop
      break;
    }

    lines.push({ x, y, line });
    line = '';
    y += lineHeight;
  }

  if (line.length > 0) {
    lines.push({ x, y, line });
  }

  return lines;
}
